import { Component } from '@angular/core';
import { DefaultUrlSerializer, PartialMatchRouteSnapshot, Routes, UrlTree } from '@angular/router';

import { ConfigService } from '@ph-core/services/config/config.service';

import { authGuard } from './core/route-guards/auth.guard';
import { loginGuard } from './core/route-guards/login.guard';
import { redirectGuard } from './core/route-guards/redirect.guard';

@Component({
  template: '',
})
class MockRouteComponent {}

const application = ConfigService.getEnvironment().application;
const urlSerializer = new DefaultUrlSerializer();

/** `/{application}/...` bookmark: drop that prefix and keep path, query, and fragment. */
export function redirectPreservingRemainder(snapshot: PartialMatchRouteSnapshot): UrlTree {
  const remainder = snapshot.url.map((segment) => segment.toString()).join('/');
  const tree = urlSerializer.parse(remainder ? `/${remainder}` : '/');
  tree.queryParams = { ...snapshot.queryParams };
  tree.fragment = snapshot.fragment;

  return tree;
}

const loadCallbackRoutes = () => import('./callback/callback-routes').then((m) => m.CALLBACK_ROUTE);

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: application,
    children: [
      // Okta redirectUri is `/{application}/callback`; redirecting would change location.href and break isLoginRedirect().
      { path: 'callback', loadChildren: loadCallbackRoutes },
      { path: '**', redirectTo: redirectPreservingRemainder },
    ],
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home-routes').then((m) => m.HOME_ROUTES),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
  },
  {
    path: 'internal',
    loadChildren: () => import('./internal/internal-routes').then((m) => m.INTERNAL_ROUTES),
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component'),
    canActivate: [loginGuard],
  },
  {
    path: 'callback',
    loadChildren: loadCallbackRoutes,
  },
  { path: 'not-found', loadComponent: () => import('./not-found/not-found.component') },
  { path: 'forbidden', loadComponent: () => import('./forbidden/forbidden.component') },
  { path: '**', canActivate: [redirectGuard], component: MockRouteComponent },
];
